import React, { useEffect, useState } from "react";
import { corefetch } from "../../../Util/axios_core_helper";

const PackagesSection = ({ id }) => {
  const [packages, setPackages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [modalContent, setModalContent] = useState("");
  const charLimit = 550;
  const fetchData = async () => {
    try {
      const list = await corefetch(
        `Packages/GetPackagesDetailsById?displayedInId=${id}`
      );
      if (list && list.length > 0) {
        setPackages(list);
      } else {
        setPackages([]);
      }
    } catch (error) {
      setPackages([]);
      console.error("Error fetching list:", error);
    }
  };
  const stripHtmlTags = (htmlString) => {
    const doc = new DOMParser().parseFromString(htmlString, "text/html");
    return doc.body.textContent || "";
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleClickPackagePoints = (content) => {
    setModalContent(content); // Set the content of the modal
    setShowModal(true); // Open the modal
  };
  const handleOpenModal = (pkg) => {
    setSelectedPackage(pkg);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setSelectedPackage(null);
    setShowModal(false);
  };

  if (!packages || packages.length == 0) {
    return null;
  }
  const formatCount = (count) => {
    if (count >= 1000000000) {
      return (
        (count / 1000000000).toFixed(count % 1000000000 === 0 ? 0 : 1) + "B"
      );
    } else if (count >= 1000000) {
      return (count / 1000000).toFixed(count % 1000000 === 0 ? 0 : 1) + "M";
    } else if (count >= 1000) {
      return (count / 1000).toFixed(count % 1000 === 0 ? 0 : 1) + "k";
    }
    return count.toString();
  };

  return (
    <>
      <section className="wpo-pricing-section section-padding pt-0">
        <div className="container">
          <div className="wpo-section-title">
            <h4>Choose Yours</h4>
            <h2>{packages[0].displayedInName} Packages</h2>
          </div>
          <div className="wpo-pricing-wrap">
            <div className="row">
              {packages.map((pkg) => (
                <div
                  key={pkg.packagesID}
                  className="col col-lg-4 col-md-6 col-sm-12"
                >
                  <div className="wpo-pricing-item">
                    <div className="wpo-pricing-top">
                      <div className="wpo-pricing-text">
                        <h4>{pkg.packageName}</h4>
                        <span
                          style={{
                            color: "#000", // Black color for Read More link
                            fontSize: "14px", // Font size for the Read More text
                            margin: "0", // Remove default margin
                            cursor: "pointer",
                            marginBottom: "10px",
                            fontFamily: "Jost, sans-serif",
                          }}
                        >
                          Starts From
                        </span>

                        <h2>
                          ${formatCount(pkg.amount)}
                          {/* ${pkg.amount} */}
                          {/* <span>/Monthly</span> */}
                        </h2>
                      </div>
                    </div>
                    <div className="shape">
                      <svg
                        className="svg"
                        width="100%"
                        height="auto"
                        viewBox="0 0 323 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_134_21)">
                          <path
                            d="M322.098 5.15702C321.737 5.15702 321.437 5.35537 321.286 5.65289H314.417C315.124 5.32704 316.011 4.74616 316.642 3.62692C317.484 2.12515 317.409 1.17591 318.22 0.0141676C318.22 0.0141676 315.695 0.708382 314.748 1.98347C313.666 3.47107 313.38 4.98701 313.305 5.65289H298.981C299.687 5.32704 300.574 4.74616 301.205 3.62692C302.047 2.12515 301.972 1.17591 302.783 0.0141676C302.783 0.0141676 300.258 0.708382 299.311 1.98347C298.229 3.47107 297.943 4.98701 297.868 5.65289H283.544C284.25 5.32704 285.137 4.74616 285.768 3.62692C286.61 2.12515 286.535 1.17591 287.347 0.0141676C287.347 0.0141676 284.821 0.708382 283.874 1.98347C282.792 3.47107 282.507 4.98701 282.431 5.65289H268.107C268.813 5.32704 269.7 4.74616 270.332 3.62692C271.173 2.12515 271.098 1.17591 271.91 0.0141676C271.91 0.0141676 269.385 0.708382 268.438 1.98347C267.355 3.47107 267.07 4.98701 266.995 5.65289H252.67C253.377 5.32704 254.263 4.74616 254.895 3.62692C255.737 2.12515 255.661 1.17591 256.473 0.0141676C256.473 0.0141676 253.948 0.708382 253.001 1.98347C251.919 3.47107 251.633 4.98701 251.558 5.65289H237.233C237.94 5.32704 238.827 4.74616 239.458 3.62692C240.3 2.12515 240.225 1.17591 241.036 0.0141676C241.036 0.0141676 238.511 0.708382 237.564 1.98347C236.482 3.47107 236.196 4.98701 236.121 5.65289H221.797C222.503 5.32704 223.39 4.74616 224.021 3.62692C224.863 2.12515 224.788 1.17591 225.599 0.0141676C225.599 0.0141676 223.074 0.708382 222.127 1.98347C221.045 3.47107 220.76 4.98701 220.684 5.65289H206.36C207.066 5.32704 207.953 4.74616 208.584 3.62692C209.426 2.12515 209.351 1.17591 210.163 0.0141676C210.163 0.0141676 207.637 0.708382 206.691 1.98347C205.608 3.47107 205.323 4.98701 205.248 5.65289H190.923C191.63 5.32704 192.516 4.74616 193.148 3.62692C193.989 2.12515 193.914 1.17591 194.726 0.0141676C194.726 0.0141676 192.201 0.708382 191.254 1.98347C190.172 3.47107 189.886 4.98701 189.811 5.65289H175.486C176.193 5.32704 177.08 4.74616 177.711 3.62692C178.553 2.12515 178.477 1.17591 179.289 0.0141676C179.289 0.0141676 176.764 0.708382 175.817 1.98347C174.735 3.47107 174.449 4.98701 174.374 5.65289H165.295C165.1 3.83943 163.507 2.42267 161.523 2.42267C159.553 2.42267 157.945 3.83943 157.765 5.65289H148.656C148.581 4.98701 148.295 3.45691 147.213 1.98347C146.266 0.694215 143.726 0 143.726 0C144.523 1.16175 144.462 2.11098 145.304 3.61275C145.92 4.73199 146.822 5.32704 147.529 5.63872H133.204C133.129 4.97285 132.844 3.44274 131.761 1.9693C130.814 0.694215 128.289 0 128.289 0C129.086 1.16175 129.026 2.11098 129.867 3.61275C130.484 4.73199 131.386 5.32704 132.092 5.63872H117.767C117.692 4.97285 117.407 3.44274 116.324 1.9693C115.378 0.694215 112.852 0 112.852 0C113.649 1.16175 113.589 2.11098 114.431 3.61275C115.047 4.73199 115.949 5.32704 116.655 5.63872H102.331C102.256 4.97285 101.97 3.44274 100.888 1.9693C99.9408 0.694215 97.4156 0 97.4156 0C98.2122 1.16175 98.1521 2.11098 98.9938 3.61275C99.6101 4.73199 100.512 5.32704 101.218 5.63872H86.8939C86.8188 4.97285 86.5332 3.44274 85.4509 1.9693C84.504 0.694215 81.9788 0 81.9788 0C82.7754 1.16175 82.7153 2.11098 83.557 3.61275C84.1733 4.73199 85.0752 5.32704 85.7816 5.63872H71.4571C71.382 4.97285 71.0964 3.44274 70.0142 1.9693C69.0672 0.694215 66.542 0 66.542 0C67.3386 1.16175 67.2785 2.11098 68.1203 3.61275C68.7365 4.73199 69.6384 5.32704 70.3448 5.63872H56.0203C55.9452 4.97285 55.6596 3.44274 54.5774 1.9693C53.6304 0.694215 51.1052 0 51.1052 0C51.9019 1.16175 51.8417 2.11098 52.6835 3.61275C53.2997 4.73199 54.2016 5.32704 54.908 5.63872H40.5836C40.5084 4.97285 40.2228 3.44274 39.1406 1.9693C38.1936 0.694215 35.6684 0 35.6684 0C36.4651 1.16175 36.405 2.11098 37.2467 3.61275C37.863 4.73199 38.7648 5.32704 39.4713 5.63872H25.1468C25.0716 4.97285 24.786 3.44274 23.7038 1.9693C22.7569 0.694215 20.2317 0 20.2317 0C21.0283 1.16175 20.9682 2.11098 21.8099 3.61275C22.4262 4.73199 23.328 5.32704 24.0345 5.63872H9.69496C9.61981 4.97285 9.33422 3.45691 8.25199 1.9693C7.32007 0.694215 4.79487 0 4.79487 0C5.59151 1.16175 5.53139 2.11098 6.37312 3.61275C6.98939 4.73199 7.89125 5.32704 8.5977 5.63872H1.71353C1.56322 5.35537 1.2626 5.14286 0.901857 5.14286C0.405836 5.15702 0 5.52538 0 5.99292C0 6.46045 0.405836 6.84297 0.901857 6.84297C1.2626 6.84297 1.57825 6.64463 1.71353 6.34711H8.58267C7.87622 6.67296 6.98939 7.268 6.35809 8.38725C5.53139 9.88902 5.59151 10.8383 4.79487 12C4.79487 12 7.32007 11.3058 8.26702 10.0307C9.33422 8.54309 9.61981 7.02715 9.69496 6.34711H24.0195C23.313 6.67296 22.4111 7.25384 21.7949 8.37308C20.9531 9.87485 21.0283 10.8241 20.2166 11.9858C20.2166 11.9858 22.7418 11.2916 23.6888 10.0165C24.771 8.52893 25.0566 7.01299 25.1317 6.34711H39.4562C38.7498 6.67296 37.8479 7.25384 37.2317 8.37308C36.3899 9.87485 36.4651 10.8241 35.6534 11.9858C35.6534 11.9858 38.1786 11.2916 39.1256 10.0165C40.2078 8.52893 40.4934 7.01299 40.5685 6.34711H54.893C54.1866 6.67296 53.2847 7.25384 52.6684 8.37308C51.8417 9.88902 51.9019 10.8383 51.1052 12C51.1052 12 53.6304 11.3058 54.5774 10.0307C55.6596 8.54309 55.9452 7.02715 56.0203 6.36127H70.3448C69.6384 6.68713 68.7365 7.268 68.1203 8.38725C67.2785 9.88902 67.3537 10.8383 66.542 12C66.542 12 69.0672 11.3058 70.0142 10.0307C71.0964 8.54309 71.382 7.02715 71.4571 6.36127H85.7816C85.0601 6.67296 84.1733 7.268 83.557 8.38725C82.7153 9.88902 82.7905 10.8383 81.9788 12C81.9788 12 84.504 11.3058 85.4509 10.0307C86.5332 8.54309 86.8188 7.02715 86.8939 6.36127H101.218C100.512 6.68713 99.6101 7.268 98.9938 8.38725C98.1521 9.88902 98.2272 10.8383 97.4156 12C97.4156 12 99.9408 11.3058 100.888 10.0307C101.97 8.54309 102.256 7.02715 102.331 6.36127H116.655C115.949 6.68713 115.047 7.268 114.431 8.38725C113.589 9.88902 113.664 10.8383 112.852 12C112.852 12 115.378 11.3058 116.324 10.0307C117.407 8.54309 117.692 7.02715 117.767 6.36127H132.092C131.386 6.68713 130.499 7.268 129.867 8.38725C129.026 9.88902 129.101 10.8383 128.289 12C128.289 12 130.814 11.3058 131.761 10.0307C132.844 8.54309 133.129 7.02715 133.204 6.36127H147.529C146.822 6.68713 145.92 7.268 145.304 8.38725C144.462 9.88902 144.538 10.8383 143.726 12C143.726 12 146.251 11.3058 147.198 10.0307C148.28 8.54309 148.566 7.02715 148.641 6.36127H157.75C157.945 8.17473 159.538 9.5915 161.508 9.5915C163.477 9.5915 165.085 8.17473 165.28 6.36127H174.359C174.434 7.02715 174.72 8.55726 175.802 10.0307C176.734 11.3058 179.274 12 179.274 12C178.477 10.8383 178.538 9.88902 177.696 8.38725C177.08 7.268 176.178 6.67296 175.471 6.36127H189.796C189.871 7.02715 190.157 8.55726 191.239 10.0307C192.171 11.3058 194.711 12 194.711 12C193.914 10.8383 193.974 9.88902 193.133 8.38725C192.516 7.268 191.615 6.67296 190.908 6.36127H205.233C205.308 7.02715 205.593 8.55726 206.676 10.0307C207.607 11.3058 210.148 12 210.148 12C209.351 10.8383 209.411 9.88902 208.569 8.38725C207.953 7.268 207.051 6.67296 206.345 6.36127H220.669C220.744 7.02715 221.03 8.55726 222.112 10.0307C223.044 11.3058 225.584 12 225.584 12C224.788 10.8383 224.848 9.88902 224.006 8.38725C223.39 7.268 222.488 6.67296 221.782 6.36127H236.106C236.181 7.02715 236.467 8.55726 237.549 10.0307C238.481 11.3058 241.021 12 241.021 12C240.225 10.8383 240.285 9.88902 239.443 8.38725C238.827 7.268 237.925 6.67296 237.218 6.36127H251.543C251.618 7.02715 251.904 8.55726 252.986 10.0307C253.918 11.3058 256.458 12 256.458 12C255.661 10.8383 255.722 9.88902 254.88 8.38725C254.264 7.268 253.362 6.67296 252.655 6.36127H266.98C267.055 7.02715 267.34 8.55726 268.423 10.0307C269.355 11.3058 271.895 12 271.895 12C271.098 10.8383 271.158 9.88902 270.317 8.38725C269.7 7.268 268.798 6.67296 268.092 6.36127H282.416C282.492 7.02715 282.777 8.55726 283.859 10.0307C284.791 11.3058 287.332 12 287.332 12C286.535 10.8383 286.595 9.88902 285.753 8.38725C285.137 7.268 284.235 6.67296 283.529 6.36127H297.853C297.928 7.02715 298.214 8.55726 299.296 10.0307C300.228 11.3058 302.768 12 302.768 12C301.972 10.8383 302.032 9.88902 301.19 8.38725C300.574 7.268 299.672 6.67296 298.966 6.36127H313.29C313.365 7.02715 313.651 8.55726 314.733 10.0307C315.665 11.3058 318.205 12 318.205 12C317.408 10.8383 317.469 9.88902 316.627 8.38725C316.011 7.268 315.109 6.67296 314.402 6.36127H321.271C321.422 6.64463 321.722 6.85714 322.083 6.85714C322.579 6.85714 322.985 6.47462 322.985 6.00708C322.985 5.53955 322.594 5.15702 322.098 5.15702Z"
                            fill="#B59186"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_134_21">
                            <rect width={323} height={12} fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div className="wpo-pricing-bottom">
                      <div className="wpo-pricing-bottom-text package-points">
                        <div
                          className="mobileView"
                          style={{
                            cursor: "pointer",
                            width: "auto",
                            height: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                          onClick={() =>
                            handleClickPackagePoints(pkg.packagesPoints)
                          }
                        >
                          <div
                            style={{
                              display: "-webkit-box",
                              WebkitLineClamp: 6, // Limit to 6 lines
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: pkg.packagesPoints,
                            }}
                          ></div>
                          {pkg.packagesPoints.length > charLimit && (
                            <span
                              style={{
                                color: "#000", // Black color for Read More link
                                fontSize: "14px", // Font size for the Read More text
                                margin: "0", // Remove default margin
                                cursor: "pointer",
                                marginBottom: "10px",
                                fontFamily: "Jost, sans-serif",
                              }}
                              onClick={() => handleOpenModal(pkg)}
                            >
                              Read More
                            </span>
                          )}
                        </div>

                        <div
                          className="mobileViewButton"
                          style={{
                            display: "flex",
                            // justifyContent: "space-between",
                            alignItems: "center",
                            marginTop: "10px",
                          }}
                        >
                          <input
                            type="button"
                            className="theme-btn buttons"
                            value={pkg.button1Name}
                            onClick={() =>
                              window.open(pkg.button1Link, "_blank")
                            }
                            style={{
                              width: "150px",
                              marginRight: "10px",
                            }}
                          />

                          <input
                            type="button"
                            className="theme-btn buttons"
                            value={pkg.button2Name}
                            onClick={() =>
                              window.open(pkg.button2Link, "_blank")
                            }
                            style={{
                              width: "150px", // Fixed width for button
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {showModal && selectedPackage && (
        <div
          className="popup"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="modal-content packages"
            style={{
              backgroundColor: "white",
              width: "80%",
              maxWidth: "500px",
              maxHeight: "80%",
              overflowY: "auto",
              borderRadius: "8px",
              padding: "20px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              position: "relative",
            }}
          >
            <span
              className="close"
              onClick={handleCloseModal}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                fontSize: "24px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              &times;
            </span>
            <div
              className="modal-header"
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                marginBottom: "10px",
              }}
            >
              {selectedPackage.packageName}
            </div>
            <div
              className="additional-text"
              style={{
                maxHeight: "400px",
                overflowY: "auto",
              }}
            >
              <p dangerouslySetInnerHTML={{ __html: modalContent }}></p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PackagesSection;
